export const TopBannerHeight = {
  data() {
    return {
      bannerHeight: 0,
      bannerObserver: null,
      mutationObserver: null,
    };
  },
  methods: {
    setBannerHeight() {
      const banner = document.querySelector('.vehicle-user-general-banner');
      this.bannerHeight = banner ? banner.offsetHeight : 0;
    },
    observeBanner() {
      const banner = document.querySelector('.vehicle-user-general-banner');
      if (banner && !this.bannerObserver) {
        this.bannerObserver = new ResizeObserver(this.setBannerHeight);
        this.bannerObserver.observe(banner);
        this.setBannerHeight();
      } else if (!banner && this.bannerObserver) {
        this.bannerObserver.disconnect();
        this.bannerObserver = null;
        this.bannerHeight = 0;
      }
    },
  },
  created() {
    this.observeBanner();
    this.mutationObserver = new MutationObserver(() => {
      this.observeBanner();
    });
    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },
  destroyed() {
    if (this.bannerObserver) this.bannerObserver.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
  },
};
